import { render } from "./AnimatedBox.vue?vue&type=template&id=989ab7a0&scoped=true"
import script from "./AnimatedBox.vue?vue&type=script&lang=js"
export * from "./AnimatedBox.vue?vue&type=script&lang=js"

import "./AnimatedBox.vue?vue&type=style&index=0&id=989ab7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989ab7a0"]])

export default __exports__